import { get } from "lodash"
import { createSelector } from "reselect"
import { numberFormatter } from "helpers/formatters/numbers"
import { getSelectedContributorCategory, getSelectedGroup } from "."
import { mapContributorsGroupDropDown } from "helpers/compositeSecuritiesDetails"

const columns = {
  group: [{
    id: "name",
    label: "",
    align: "left",
    getter: get,
  }, {
    id: "totalPercentEquity",
    label: "% Equity",
    getter: get,
    formatter: (number) => numberFormatter(number * 100),
  }, {
    id: "value",
    label: "Absolute",
    getter: get,
    formatter: numberFormatter,
  }],
  details: [{
    id: "label",
    label: "",
    align: "left",
    getter: get,
  }, {
    id: "value",
    label: "Beta (Absolute)",
    getter: get,
    formatter: numberFormatter,
  }],
}

const getSelectedOption = (_, props) => props.selectedOption
const getCurrentGrouping = (_, props) => props.currentGrouping

export const getGroupsDropdownColumns = createSelector(
  [getSelectedContributorCategory, getSelectedOption, getSelectedGroup, getCurrentGrouping],
  (selected, selectedOption, selectedGroup, contributorsGrouping) =>
    mapContributorsGroupDropDown(columns, selected, selectedOption, selectedGroup, contributorsGrouping),
)
